import LaudoVisita from 'entity/LaudoVisita';
import _ from 'lodash'
export const exportJsonVisitas = async (listaVisitas) => {
    let strCsv = '';
    let separator = ';'

    const findAddColetasQT = (obj, qt) => {
        if (obj && obj.coletas && obj.coletas.length) {
            qt = qt + obj.coletas.length

        }

        // console.log('obj', obj)
        for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key];
                if (element) {


                    if (Array.isArray(element)) {
                        // eslint-disable-next-line no-loop-func
                        element.forEach(n => {
                            if (n)
                                qt = findAddColetasQT(n, qt)
                        });
                    } else
                        if (typeof element === 'object') {
                            qt = findAddColetasQT(element, qt)
                        }

                }
            }
        }
        return qt
    }
    listaVisitas.forEach(visita => {
        if (!visita) {
            return
        }
        const { uid, sequencialIndex, cliente, tecnico, cultura, safra } = visita;
        const { data, dataLastChangeISO, dataLastChangeStr, dataStr } = visita;
        let strIndicadores = LaudoVisita.generateStrIndicador(visita)
        let qtColetas = 0
        qtColetas = findAddColetasQT(visita, qtColetas)

        let clearVisita = {
            uid,
            sequencialIndex,
            data, dataLastChangeISO, dataLastChangeStr, dataStr,
            clienteNome: cliente?.nome?.toUpperCase(), clienteUid: cliente?.uid,
            tecnicoNome: tecnico?.nome?.toUpperCase(), tecnicoUid: tecnico?.uid, tecnicoEmail: tecnico?.email,
            cultura: cultura?.cultura?.toUpperCase(),
            strIndicadores,
            safra: safra?.safra?.toUpperCase(),
            qtColetas
        }


        // let v = ""
        // v += uid + separator
        // v += sequencialIndex + separator

        // v += '"' + clearVisita.clienteNome + '"' + separator


        // strCsv += v + separator
        if (!strCsv) {
            for (const key in clearVisita) {
                strCsv += key + separator
            }

            strCsv += '\n'
        }
        for (const key in clearVisita) {

            if (Object.hasOwnProperty.call(clearVisita, key)) {
                const element = clearVisita[key];
                let v = ""
                if (!element) {
                    v = ''
                } else {
                    v = '"' + element + '"'
                }
                strCsv += v + separator
            }
        }
        strCsv += '\n'
    });
    gerarArquivo(strCsv, "Visitas.csv")

}

export const exportJson = async (data, nomeArquivo) => {


    gerarArquivo(JSON.stringify(data), nomeArquivo + ".json")

}
export const exportCsv = async (conf, data, nomeArquivo) => {
    let strCsv = '';
    let separator = ';'
    conf.forEach(c => { strCsv += c.labelCol + separator })
    strCsv += '\n'
    data.forEach(l => {
        conf.forEach(c => {
            let v = ""
            if (_.isString(c.getValue)) {
                v = _.get(l, c.getValue);
                if (v) {
                    v = '"' + v + '"'
                }
            } else {
                v = c.getValue(l);
            }
            if (!v) {
                v = ''
            }
            strCsv += v + separator
        })
        strCsv += '\n'
    })
    gerarArquivo(strCsv, nomeArquivo + ".csv")

}

const gerarArquivo = (texto, nome) => {

    let fileBlob = new Blob(["\ufeff", texto]);
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = "";
            console.log('window.cordova', window.cordova)
            storageLocation = window.cordova.file.dataDirectory;

            var folderPath = storageLocation;
            console.log('folderPath', folderPath)
            console.log('nome', nome)
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir);
                    dir.getFile(
                        nome,
                        {
                            create: true
                        },
                        function (file) {
                            console.log('file', file)
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob);

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL();
                                        console.log('url', url)
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err);
                                                alert("Unable to download3");
                                            },
                                            success: function success() {
                                                console.log("success with opening the file");
                                            }
                                        });
                                    };

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2");
                                        console.error(err);
                                    };
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download");
                                    console.error('err', err);
                                }
                            );
                        },
                        function (err) {
                            alert("Unable to download");
                            console.error(err);
                        }
                    );
                },
                function (err) {
                    alert("Unable to download");
                    console.error(err);
                }
            );
        });
    } else {

        var element = document.createElement("a");

        element.href = URL.createObjectURL(fileBlob);
        element.download = nome;
        element.click();
    }
}